'use client'

import { useLocale } from 'next-intl'
import { getLocaleConfig } from '@/config/locale-config'
import { Locale } from '@/i18n/routing'
import { LocaleConfig } from '@/config/types'

export function useLocaleConfig(): LocaleConfig {
  const locale = useClientLocale()
  return getLocaleConfig(locale)
}

export function useClientLocale(): Locale {
  return useLocale() as Locale
}
